/**
 * Frontend Script
 */


jQuery(document).ready(function ($) {


})


// WEBPACK FOOTER //
// ./src/blocks/flag/js/script.js